<template>
  <v-container v-if="!loading">
    <v-row>
      <v-col cols="12" md="9" lg="7" class="mx-auto text-center pa-0">
        <h3>Following Chefs</h3>
      </v-col>
      <v-col cols="12" sm="1">
        <v-btn fab dark color="primary" @click.prevent="refresh">
          <v-icon dark>cached</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="list && list.length > 0">
      <v-col cols="12" sm="4" v-for="chef in list" :key="chef.id" class="mb-2">
        <chef-view :selectedChef="chef" />
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12" sm="6" v-html="$t('Chef.following_chefs_empty')"></v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import ChefView from './public/ChefView'

export default {
  components: {
    ChefView
  },
  computed: {
    ...mapGetters({
      loading: 'loading'
    })
  },
  data() {
    return {
      profile: null,
      list: []
    }
  },
  mounted() {
    this.$store.dispatch('loadProfile').then(profile => {
      this.profile = profile
      this.loadFollowingChefs()
    })
  },

  methods: {
    refresh() {
      this.$store.dispatch('loadProfile').then(profile => {
        this.profile = profile
        this.loadFollowingChefs()
      })
    },
    loadFollowingChefs() {
      if (this.profile && this.profile.id) {
        this.$store
          .dispatch('loadFollowingChefs', this.profile.id)
          .then(list => {            
            this.list = list
          })
      } else {
        console.log('following chefs list is empty')
      }
    }
  }
}
</script>
